import { TitleContent } from "./styled";

export const Title = ({ title, ...props }) => {
  return (
    <TitleContent {...props}>
      {title}
    </TitleContent>
  );
};
